<template>
  <div class="main">
	<router-view></router-view>
  </div>
</template>

<script>
  export default {
    components: {},
    methods: {},
	mounted: function () {
		this.$storageConfig({
			name: 'erp'
		})
	}
  }
</script>

<style>
	html {
		height: 100%;
	}
	body {
		height: 100%;
		margin: 0;
		font-family: 'Roboto', sans-serif;
		font-size:95%;
		font-weight:400;
		background-color: #eee;
		color: #333;
	}
	
	* {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
	}	

	a {
		cursor:pointer;
	}

	.fColorHighlight {
		color: #1d88e6;
	}

	.fColorGrey {
		color: #888;
	}

	.fColorNavigation {
		color: #555;
	}
	
	iframe {
		width: 0;
		height: 0;
		border: 0;
		border: none;
	}
	
	.main {
	  width:100%;
	  height:100%;
	}

	.noselect {
	  -webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Safari */
		 -khtml-user-select: none; /* Konqueror HTML */
		   -moz-user-select: none; /* Firefox */
			-ms-user-select: none; /* Internet Explorer/Edge */
				user-select: none; /* Non-prefixed version, currently
									  supported by Chrome and Opera */
	}
/*
===============================================
START: RESPONSIVE GRID SYSTEM
http://www.responsivegridsystem.com/calculator/
===============================================
*/

/*  RESPONSIVE GRID SYSTEM -> SECTIONS  */
.section {
	clear: both;
	padding: 0px;
	margin: 0px;
	max-width:1500px;
}

/*  RESPONSIVE GRID SYSTEM -> COLUMN SETUP  */
.col {
	display: block;
	float:left;
	margin: 0.5% 0 0.5% 1.6%;
}
.col:first-child { margin-left: 0; }

/*  RESPONSIVE GRID SYSTEM -> GROUPING  */
.group:before,
.group:after { content:""; display:table; }
.group:after { clear:both;}
.group { zoom:1; /* For IE 6/7 */ }

/*  GRID OF TWELVE  */
.span_12_of_12 {
	width: 100%;
}

.span_11_of_12 {
  	width: 91.53%;
}
.span_10_of_12 {
  	width: 83.06%;
}

.span_9_of_12 {
  	width: 74.6%;
}

.span_8_of_12 {
  	width: 66.13%;
}

.span_7_of_12 {
  	width: 57.66%;
}

.span_6_of_12 {
  	width: 49.2%;
}

.span_5_of_12 {
  	width: 40.73%;
}

.span_4_of_12 {
  	width: 32.26%;
}

.span_3_of_12 {
  	width: 23.8%;
}

.span_2_of_12 {
  	width: 15.33%;
}

.span_1_of_12 {
  	width: 6.866%;
}

/*  GO FULL WIDTH BELOW 480 PIXELS */
@media only screen and (max-width: 850px) {
	.col {  margin: 1% 0 1% 0%; }
    
    .span_1_of_12, .span_2_of_12, .span_3_of_12, .span_4_of_12, .span_5_of_12, .span_6_of_12, .span_7_of_12, .span_8_of_12, .span_9_of_12, .span_10_of_12, .span_11_of_12, .span_12_of_12 {
	width: 100%; 
	}
}

/*nachfolgende Zeilen werden für die LargeButtons benötigt*/
@media only screen and (max-width: 1100px) {
	.col.btn {  margin: 1% 0 1% 0%; }
    
    .span_1_of_12.btn, .span_2_of_12.btn, .span_3_of_12.btn, .span_4_of_12.btn, .span_5_of_12.btn, .span_6_of_12.btn, .span_7_of_12.btn, .span_8_of_12.btn, .span_9_of_12.btn, .span_10_of_12.btn, .span_11_of_12.btn, .span_12_of_12.btn {
	width: 100%; 
	}
}
/*
===============================================
END: RESPONSIVE GRID SYSTEM
===============================================
*/

</style>
